// =========================================================
// MENU MOBILE custom (KM Matériaux) — bundle EAGER (menu.js). BY-PASS TOTAL
// du système base (#pdw-mobile-menu / pdw_mobile_menu.js) :
// 1. Ouverture/fermeture du panneau (.show) via .km-mm-open / .km-mm-close + Échap.
// 2. Sous-menus en accordéon : un bouton chevron par parent, toggle .is-open.
// 3. Scroll de page gelé quand le panneau est ouvert.
// =========================================================
document.addEventListener('DOMContentLoaded', () => {

    const menu = document.getElementById('km-mobile-menu');
    if (!menu) return;

    // ----- Ouverture / fermeture -----
    // ----- Carte « Le magasin » : statut ouvert / fermé à l'heure de Bruxelles -----
    // Calculé ici et à chaque ouverture (jamais en PHP : la page est mise en cache).
    // Une ligne d'horaires non comprise (days vide) n'entre pas dans le calcul ; si aucune
    // ne l'est, le statut reste masqué plutôt que d'afficher une information fausse.
    const shop = menu.querySelector('.km-mm__shop[data-hours]');
    const updateStatus = () => {
        if (!shop) return;
        let rows;
        try { rows = JSON.parse(shop.dataset.hours); } catch (e) { return; }
        if (!rows.some((r) => r.d.length)) return;

        const now = new Date(new Date().toLocaleString('en-US', {timeZone: 'Europe/Brussels'}));
        const day = now.getDay();
        const min = now.getHours() * 60 + now.getMinutes();
        const fmt = (m) => Math.floor(m / 60) + 'h' + String(m % 60).padStart(2, '0');
        const dayNames = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

        shop.querySelectorAll('.km-mm__hours li').forEach((li) => li.classList.remove('is-today'));
        const todayIdx = rows.findIndex((r) => r.d.includes(day));
        if (todayIdx > -1) shop.querySelector(`.km-mm__hours li[data-row="${todayIdx}"]`)?.classList.add('is-today');

        let text;
        let isOpen = false;
        const today = rows[todayIdx];
        if (today && min >= today.o && min < today.c) {
            isOpen = true;
            text = 'Ouvert · ferme à ' + fmt(today.c);
        } else if (today && min < today.o) {
            text = 'Fermé · ouvre à ' + fmt(today.o);
        } else {
            // prochain jour ouvert dans la semaine
            for (let k = 1; k <= 7; k++) {
                const d = (day + k) % 7;
                const r = rows.find((x) => x.d.includes(d));
                if (r) {
                    text = 'Fermé · ouvre ' + (k === 1 ? 'demain' : dayNames[d]) + ' à ' + fmt(r.o);
                    break;
                }
            }
        }
        if (!text) return;
        const status = shop.querySelector('.km-mm__status');
        status.querySelector('span').textContent = text;
        status.querySelector('.km-mm__dot').classList.toggle('is-closed', !isOpen);
        status.hidden = false;
    };
    updateStatus();

    const open = () => {
        updateStatus();
        menu.classList.add('show');
        document.body.style.overflow = 'hidden';
    };
    const close = () => {
        menu.classList.remove('show');
        document.body.style.overflow = '';
    };

    document.querySelectorAll('.km-mm-open').forEach((el) => el.addEventListener('click', open));
    document.querySelectorAll('.km-mm-close').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && menu.classList.contains('show')) close();
    });

    // ----- Accordéons de sous-menus -----
    menu.querySelectorAll('.menu-item-has-children').forEach((li) => {
        const link = li.querySelector(':scope > a');
        const sub = li.querySelector(':scope > .sub-menu');
        if (!link || !sub) return;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'km-mm__sub-toggle';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Ouvrir le sous-menu');
        link.after(btn);

        btn.addEventListener('click', () => {
            const isOpen = li.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
    });
});
